<template>
  <div>
    <div v-if="opportunities && opportunities.length">
      <table-widget
        :items="opportunities"
        :perPage="perPage"
        :totalRows="totalRows"
        :current-page.sync="currentPage"
        :filter.sync="filter"
      >
        <template slot="buttons">
          <!-- <b-button class="ml-2" v-if="canAddOpportunity"><font-awesome-icon icon="plus" /> New Opportunity</b-button> -->
          <b-button
            type="button"
            class="ml-2"
            v-if="canAddOpportunity"
            :to="{ name: 'opportunityAdd', query: { siteId: siteId } }"
            ><font-awesome-icon icon="plus" /> New Opportunity</b-button
          >
        </template>
        <template slot="content">
          <b-table
            striped
            :items="opportunities"
            :fields="fields"
            :per-page="perPage"
            :current-page="currentPage"
            :filter="filter"
            @filtered="onFiltered"
            sortBy="opportunityCategory"
            small
          >
            <template slot="term" slot-scope="data">
              {{ data.item.term.description }}
            </template>
            <template slot="opportunityCategory" slot-scope="data">
              {{ data.item.opportunityCategory.name }}
            </template>
            <template slot="view" slot-scope="data">
              <router-link
                :to="{
                  name: 'opportunity',
                  params: { opportunityId: data.item.opportunityId },
                }"
                >View</router-link
              >
            </template>
          </b-table>
        </template>
      </table-widget>
    </div>

    <p v-if="opportunities && !opportunities.length">
      There are no Opportunities to show.
    </p>
  </div>
</template>

<script>
import { mapState } from "vuex";
import * as _ from "lodash"; // eslint-disable-line no-unused-vars
import roleChecks from "../../misc/role-checks";
import TableWidget from "../table-widget";

export default {
  mixins: [roleChecks],
  data() {
    return {
      currentPage: 1,
      perPage: 10,
      filter: null,
      totalRows: 0,
    };
  },

  components: {
    "table-widget": TableWidget,
  },

  props: {
    opportunities: {
      type: Array,
    },
    siteId: {},
  },

  watch: {
    opportunities: function () {
      this.totalRows = this.opportunities.length;
    },
  },

  computed: {
    ...mapState({
      user: (state) => state.auth.user,
    }),

    canAddOpportunity: function () {
      return _.find(this.user.userRoles, function (userRole) {
        return userRole === "Placements.Advisor";
      });
    },

    fields: function () {
      var fieldsArray = [
        { key: "term" },
        { key: "name", label: "Name / Title", sortable: true },
        { key: "opportunityCategory", label: "Category" },
        {
          key: "positionsAvailable",
          label: "No of Positions",
        },
      ];
      if (this.isOpportunitiesViewer || this.isOpportunitiesManager) {
        fieldsArray.push({ key: "view", label: "" });
      }
      return fieldsArray;
    },
  },

  methods: {
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
  },
};
</script>

<style scoped>
</style>
